import Login from "@/views/platform/Login.vue";
import Platform from "@/views/platform/Platform.vue";
import Register from "@/views/platform/Register.vue";
import NProgress from "nprogress";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "會員登入",
    component: Login,
    meta: { title: "登入 | Quarter Car Part." }
  },
  {
    path: "/register",
    name: "會員註冊",
    component: Register,
    meta: { title: "註冊 | Quarter Car Part." }
  },
  {
    path: "/",
    component: Platform,
    children: [
      {
        path: "",
        name: "首頁",
        component: () => import("@/components/platform/Product.vue"),
        meta: { title: "Quarter Car Part." }
      },
      {
        path: "shopping-car",
        name: "購物車",
        component: () => import("@/components/platform/ShoppingCar.vue"),
        meta: { title: "購物車 | Quarter Car Part." }
      },
      {
        path: "callBack/:id",
        name: "完成訂單",
        props: true,
        component: () => import("@/components/platform/CallBack.vue"),
        meta: { title: "完成訂單 | Quarter Car Part." }
      },
      {
        path: "user",
        name: "會員資料",
        component: () => import("@/components/platform/User.vue"),
        meta: { title: "會員資料 | Quarter Car Part." }
      },
      {
        path: "order",
        name: "訂單查詢",
        component: () => import("@/components/platform/Order.vue"),
        meta: { title: "訂單查詢 | Quarter Car Part." },
        props: route => ({
          search: route.query.search
        })
      },
      {
        path: "shopping-note",
        name: "購物須知",
        component: () => import("@/components/platform/ShoppingNote.vue"),
        meta: { title: "購物須知 | Quarter Car Part." }
      },
      {
        path: "vendor",
        name: "廠商介紹",
        component: () => import("@/components/platform/Vendor.vue"),
        meta: { title: "廠商介紹 | Quarter Car Part." },
        props: route => ({
          search: route.query.search
        })
      },
      {
        path: "*",
        name: "該頁無法顯示",
        component: () => import("@/components/NotFoundComponent.vue"),
        meta: { title: "404 Error | Quarter Car Part." }
      }
    ]
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.beforeEach(async (to, from, next) => {
  const platformToken = localStorage.getItem("platform-api_token");
  const hasLogin = !!platformToken && platformToken != "undefined";
  window.document.title = to.meta.title;
  if (to.path == "/login") {
    if (hasLogin) {
      next({ name: "首頁" });
    } else {
      next();
    }
  } else if (to.path == "/register") {
    if (hasLogin) {
      next({ name: "首頁" });
    } else {
      next();
    }
  } else {
    if (hasLogin) {
      next();
    } else {
      next({ name: "會員登入" });
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

router.onError(error => {
  if (/Loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});
export default router;
